<!--
  메인배너 스와이퍼 컴포넌트
-->
<template>
  <div
    :id="idPrefix + bannerId"
    class="banner_wrapper"
  >
    <div class="banner_content">

      <!-- 배너 리스트 -->
      <div
        :class="['wrap_banner_list', 'banner_' + slidesPerView, {'swiper-container' : isSwiper}]"
      >
        <div
          :class="['inner', {'swiper-wrapper' : isSwiper}]"
        >
          <div
            v-for="(item, index) in bannerData"
            :key="index"
            :class="['banner_list', {'swiper-slide' : isSwiper}]"
          >
            <a
              :href="item.link"
              :style="'background-color:' + item.bgColor"
              class="banner_link"
            >
              <img
                :src="isDesktop ? item.imgPc : item.imgMo"
                :alt="item.title"
                class="banner_img"
              >
            </a>
          </div>
        </div>

      </div>
      <!-- // 배너 리스트 -->

      <!-- swiper navigation -->
      <div
        v-if="isSwiper"
        class="swiper_nav
      ">
        <div class="swiper-button-prev" />
        <div class="swiper-button-next" />
      </div>
      <!-- // swiper navigation -->

    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'CompMainBanner',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    // 캠페인 ID
    bannerId: {
      type: String,
      default: ''
    },
    slidesPerView: {
      type: Number,
      default: 2
    }
  },
  data () {
    return {
      idPrefix: 'banner_', // wrapper ID 앞에 추가되는 고정 값 (id="banner_'캠페인 ID''")
      viewportWidth: 0, // 브라우저 뷰포트 width
      viewportHeight: 0, // 브라우저 뷰포트 height
      isSwiper: false, // 배너 갯수가 2개 이상인 경우 swiper 처리를 위한 값
      swiperInstance: null, // 스와이퍼 인스턴스 객체 저장용
      bannerData: null, // 배너 데이터
      // 스와이퍼 옵션
      swiperOption: {
        slidesPerView: this.slidesPerView,
        slidesPerGroup: this.slidesPerView,
        spaceBetween: this.slidesPerView === 1 ? 0 : 20,
        loop: false,
        navigation: {
          prevEl: `#banner_${this.bannerId} .swiper-button-prev`,
          nextEl: `#banner_${this.bannerId} .swiper-button-next`
        },
        breakpoints: {
          1200: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            loop: true
          }
        }
      }
    }
  },
  computed: {
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    }
  },
  mounted () {
    this.getBannerData() // 배너 데이터 설정
  },
  beforeDestroy () {
    this.destroySwiper()
  },
  methods: {
    // 배너 데이터 설정
    getBannerData () {
      let result
      // NOTE: 데이터 처리

      result = [
        {
          title: '진행중인 이벤트 참여하기 1',
          imgPc: 'https://fakeimg.pl/800x150/b6d4f9/eee/?text=banner_1',
          imgMo: 'https://fakeimg.pl/800x150/b6d4f9/eee/?text=banner_1',
          bgColor: '#b6d4f9',
          link: 'javascript:void(0)'
        },
        {
          title: '진행중인 이벤트 참여하기 2',
          imgPc: 'https://fakeimg.pl/800x150/000/eee/?text=banner_2',
          imgMo: 'https://fakeimg.pl/800x150/000/eee/?text=banner_2',
          bgColor: '#000',
          link: 'javascript:void(0)'
        },
        {
          title: '진행중인 이벤트 참여하기 3',
          imgPc: 'https://fakeimg.pl/800x150/b6d4f9/eee/?text=banner_1',
          imgMo: 'https://fakeimg.pl/800x150/b6d4f9/eee/?text=banner_1',
          bgColor: '#b6d4f9',
          link: 'javascript:void(0)'
        },
        {
          title: '진행중인 이벤트 참여하기 4',
          imgPc: 'https://fakeimg.pl/800x150/000/eee/?text=banner_2',
          imgMo: 'https://fakeimg.pl/800x150/000/eee/?text=banner_2',
          bgColor: '#000',
          link: 'javascript:void(0)'
        }
      ]

      this.bannerData = result
      if (this.bannerData.length > 1) {
        this.isSwiper = true
      }
      this.initSwiper()
    },
    // 배너 갯수가 1개 이상인 경우 배너 스와이퍼 설정
    initSwiper () {
      this.$nextTick(function () {
        if (this.isSwiper) {
          const bannerId = `#${this.idPrefix}${this.bannerId}`
          const swiperContainer = document.querySelector(bannerId + ' .swiper-container')

          this.swiperInstance = new Swiper(swiperContainer, this.swiperOption)
        }
      })
    },
    destroySwiper () {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/CompMainBanner.vue